<template>
<!-- <div> -->
  <v-dialog v-model="bMostrarModal" persistent max-width="680px">
    <v-card>
      <v-toolbar
        color="headformsdark"
        height="45"
        elevation="0"
        dense
        dark>
        <v-spacer></v-spacer>
        <span class="mdlHeadForms">Asistentes</span>
        <v-spacer></v-spacer>
        <v-btn 
          color="btncolor-dark"
          @click="CloseDialog()"
          icon
          small
          dark
          outlined>
          <v-icon size="14px">fa fa-times</v-icon>
        </v-btn>
      </v-toolbar>
        <!-- <section> -->
      <v-card-text>
        <v-card v-for="(oItem, nIndex) in aData" :key="nIndex" class="my-2 border-card text-center" >
          <v-card-text class="ColumnaResumida under-sec-flat titlesdark--text py-1 px-2">
              {{oItem[oCampos.sAsistente]}}
          </v-card-text>
          <v-card-text class="text-center">
            <v-img
              :lazy-src="oItem[oCampos.sFirma]"
              max-height="150"
              max-width="250"
              :src="oItem[oCampos.sFirma]"
              class="margin-auto"
            ></v-img>
          </v-card-text>
        </v-card>  

        <!-- Card de muestra con datos quemados -->
         <!-- <v-card v-for="i in 2" :key="i" class="my-2 border-card text-center" >
          <v-card-text class="ColumnaResumida under-sec-flat titlesdark--text py-1 px-2">
              Nombre del asistente
          </v-card-text>
          <v-card-text class="text-center">
            <v-img
            src="@/assets/firma-muestra.png"
            max-height="150"
            max-width="250" 
            class="margin-auto">
            </v-img>
          </v-card-text>
        </v-card>  -->

      </v-card-text>
    <!-- </section> -->
    </v-card>  


  </v-dialog>
            
  <!-- </div> -->
</template>

<script>
import axiosServices from '@/services/axiosServices.js'
import oJsonAnexos from '@/assets/file/json_anexos.js'

export default {
  name:"ModalFirmas",
  props: {
    oDataParent: {
      type: Object,
      default: () => {}
    },
    bMostrarModal: {
      type: Boolean,
      default: false
    },
    sIdCampo: { // Se recibe el nombre del campo de la llave principapara extracto el id valor 
      type: String,
      default: ''
    },
    sNombreTabla: {
      type: String,
      default: ''
    },
  },
  // 
  components: {},
  data() {
      return {
        sIdLlaveForanea: '', // Indica elid d e filtro para traer la info
        aData:[], // Informacion de las firmas
        oCampos: {},
      }
  },
  async mounted(){
    if(oJsonAnexos.hasOwnProperty(this.sNombreTabla)){
      this.oCampos = oJsonAnexos[this.sNombreTabla].oFirmas
      this.sIdLlaveForanea = this.oDataParent[this.sIdCampo]
      var  sParams = 'sTabla='+ oJsonAnexos[this.sNombreTabla].oFirmas.sTablaAnexos + '&' + 'nValor=' + this.sIdLlaveForanea + `&oCampos=${JSON.stringify(this.oCampos)}` 
      
      const  aRespuesta = await axiosServices.getConfiguration('/pGrids_Firmas', true ,sParams)
      this.aData = aRespuesta.aData
    }
  },
  methods: {
    CloseDialog() {
      this.$emit('input', false)
    },
  },
  
}
</script>

<style lang="scss" scoped>

</style>